<div class="confirm-dialog">
    <img class="dialog-icon" src={{urlImage}} />
    <label class="dialog-lbl"> {{message}} </label>
</div>